import React from "react";
import { loginWithGoogle } from "../assets/Logic/auth";
//error protection
const SignupPage: React.FC = () => {
  const handleSignup = async () => {
    try {
      await loginWithGoogle();
    } catch (error) {
      console.error("Signup failed:", error);
    }
  };
// idk if this works
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <h1 className="text-3xl font-bold mb-6">Create an Account</h1>
      <button
        onClick={handleSignup}
        className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
      >
        Sign up with Google
      </button>
    </div>
  );
};

export default SignupPage;
